import React from "react";

import moment from "moment/moment";
import Flatpickr from "react-flatpickr";

import Modal from 'react-bootstrap/Modal'

import CodeInput from "../item/CodeInput";

import AsyncSelect from "../common/AsyncSelect";
import Separator from "../common/Separator";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import General from "../../../utils/General";
import Select from "../common/Select";

const DISCREPANCY_OPTIONS = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false
  }
]

const ROLE_OPTIONS = [
  {
    label: "Carrier",
    value: "1",
  },
  {
    label: "Customs",
    value: "2"
  },
  {
    label: "Port Authority",
    value: "3"
  },
  {
    label: "Other",
    value: "4"
  },
]

export default class Departure extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
      personConfirmingExit: {},
      submission: props.submission,
      isCDSSubmission: props.submission.form.type === "cds",
    }
  }


  _isFormValid(){
    let {
      country,
      location,
      departedAt,
      locationType,
      transportMode,
      transportNationality,
      isCDSSubmission,
      manifestNumber,
      discrepanciesExist,
      personConfirmingExit
    } = this.state

    let error = null

    if(!departedAt){
      error = "Please specify a departure time"
    }
    else if(isCDSSubmission){
     if(!country){
        error = "Please select a country"
      }
      else if(!locationType){
        error = "Please select a location type"
      }
      else if(!location){
        error = "Please select a location"
      }
      else if(!transportMode){
        error = "Please select a transport mode"
      }
      else if(!transportNationality){
        error = "Please select a transport nationality"
      }
    }
    else{
      if(!manifestNumber){
        error = "Please enter a manifest number"
      }
      else if(discrepanciesExist == null){
        error = "Please select whether discrepancies exist"
      }
      else if(!personConfirmingExit?.role){
        error = "Please select the role of the person confirming exit"
      }
    }


    if(error){
      Notify.error(error)
      return false
    }

    return true
  }

  _save(name){
    let {
      submission,
      country,
      location,
      departedAt,
      locationType,
      transportId,
      transportMode,
      transportNationality,
      isCDSSubmission,
      manifestNumber,
      discrepanciesExist,
      personConfirmingExit,
    } = this.state

    if(!this._isFormValid()){
      return
    }

    let data = isCDSSubmission ? {
      country: country.id,
      location: location.id,
      departure_at: departedAt,
      submission: submission.id,
      location_type: locationType.id,
      transport_id: transportId,
      transport_mode: transportMode.id,
      transport_nationality: transportNationality.id
    } : {
      departure_at: departedAt,
      submission: submission.id,
      manifest_number: manifestNumber,
      discrepancies_exist: discrepanciesExist,
      person_confirming_exit: personConfirmingExit
    }

    this.setState({ loading: true })
    Backend.departureNotification(data)
    .then(submission => {
      this.props.onDeparted()
      Notify.success("Departure Notification Sent!")
      this.setState({ loading: false })
    }).catch(e => {
      Notify.error(e.message)
      this.setState({ loading: false })
    })
  }

  _renderCDSContent(){
    const {
      country,
      location,
      locationType,
      transportId,
      transportMode,
      transportNationality
    } = this.state

    return (
      <>
        <Separator text="Location"/>

        <div className="col-md-4">
          <CodeInput
            placeholder={"Country Code"}
            listKey={"CountryCodesFullList_CDS"}
            value={country}
            required={true}
            editable={true}
            onSelected={country => {
              this.setState({ country })
            }}
          />
        </div>

        <div className="col-md-4">
          <CodeInput
            placeholder={"Location Type"}
            listKey={"LocationType_CDS"}
            value={locationType}
            required={true}
            editable={true}
            onSelected={locationType => {
              this.setState({ locationType })
            }}
          />
        </div>

        <div className="col-md-4">
          <label className="mb-2">Location Identifier</label>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Identifier"
              value={"U - UN/LOCODE"}
              disabled
              style={{ height: 48}}
            />
          </div>
        </div>

        <div className="col-md-12">
          <CodeInput
            placeholder={"Location"}
            listKey={"LocationOfGoodsCode_CDS"}
            value={location}
            required={true}
            editable={true}
            onSelected={location => {
              this.setState({ location })
            }}
          />
        </div>

        <Separator text="Transport"/>

        <div className="col-md-6">
          <CodeInput
            placeholder={"Transport Mode"}
            listKey={"TransportMode_CDS"}
            value={transportMode}
            required={true}
            editable={true}
            onSelected={transportMode => {
              this.setState({ transportMode })
            }}
          />
        </div>

        <div className="col-md-6">
          <CodeInput
            placeholder={"Transport Nationality"}
            listKey={"CountryCodesFullList_CDS"}
            value={transportNationality}
            required={true}
            editable={true}
            onSelected={transportNationality => {
              this.setState({ transportNationality })
            }}
          />
        </div>

        <div className="col-md-12">
          <label>Transport ID</label>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Transport ID"
              value={transportId}
              onChange={e => {
                this.setState({transportId: e.target.value || null})
              }}
            />
          </div>
        </div>
      </>
    )
  }

  _renderAESContent(){
    const {
      manifestNumber,
      discrepanciesExist,
      personConfirmingExit,
    } = this.state

    return (
      <>
        <Separator text="Location"/>

        <div className="col-md-12">
          <label className="mb-2">Manifest Number</label>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Manifest Number"
              value={manifestNumber}
              style={{height: 48}}
              onChange={e => {
                this.setState({manifestNumber: e.target.value || null})
              }}
            />
          </div>
        </div>

        <div className="col-md-12">
          <label className="mb-2">Discrepancies Exist</label>
          <div className="mb-3">
            <Select
              value={discrepanciesExist}
              options={DISCREPANCY_OPTIONS}
              placeholder="Select an option"
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              className={"custom-async-select__container"}
              classNamePrefix={"custom-async-select"}
              onSelected={(option) => {
                this.setState({discrepanciesExist: option?.value });
              }}
            />
          </div>
        </div>

        <Separator text="Person Confirming Exit"/>

        <div className="col-md-12">
          <label className="mb-2">Role</label>
          <div className="mb-3">
            <Select
              value={personConfirmingExit.role}
              options={ROLE_OPTIONS}
              placeholder="Select an option"
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              className={"custom-async-select__container"}
              classNamePrefix={"custom-async-select"}
              onSelected={(option) => {
                personConfirmingExit.role = option.value;
                this.setState({personConfirmingExit});
              }}
            />
          </div>
        </div>

        <div className="col-md-12">
          <label className="mb-2">Identification Number</label>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Identification Number"
              value={personConfirmingExit.identification_number}
              style={{height: 48}}
              onChange={e => {
                personConfirmingExit.identification_number = e.target.value || null
                this.setState({personConfirmingExit})
              }}
            />
          </div>
        </div>

        <div className="col-md-12">
          <label className="mb-2">Reference Number</label>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Reference Number"
              value={personConfirmingExit.reference_number}
              style={{height: 48}}
              onChange={e => {
                personConfirmingExit.reference_number = e.target.value || null
                this.setState({personConfirmingExit})
              }}
            />
          </div>
        </div>
      </>
    )
  }

  render() {
    let {
      show,
      loading,
      departedAt,
      isCDSSubmission,
    } = this.state

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          className={'sub-modal'}
          dialogClassName={"modal-50"}
        >
          <Modal.Header closeButton>
            <Modal.Title>Depart</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="flex-column" data-kt-stepper-element="content">
              <div className="row">

                <div className="col-md-12">
                  <div className="mb-5">
                    <label className={"mb-2"}>Departure Time</label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Departure Time"
                      value={departedAt}
                      options={{
                        enableTime: true,
                        noCalendar: false,
                        dateFormat: "Y-m-d H:i K"
                      }}
                      onChange={dates => {
                        let departedAt = moment(dates[0]).format('YYYY-MM-DDThh:mm:ss')
                        this.setState({ departedAt })
                      }}
                    />
                  </div>
                </div>

                { isCDSSubmission ? this._renderCDSContent() : this._renderAESContent()}

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary px-6"
                onClick={() => this._save()}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Modal.Footer>

        </Modal>
      </>
    )
  }
}

Departure.defaultProps = {

}
